import { motion } from "framer-motion";
import { ReactNode } from "react";
import { scaleOnHover } from "../../styles/animations";
import { gradients } from "../../styles/gradients";
import { typography, textColors } from "../../styles/typography";

interface FeatureCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  gradient?: string;
}

export const FeatureCard = ({ icon, title, description, gradient }: FeatureCardProps) => {
  return (
    <motion.div
      initial="rest"
      whileHover="hover"
      variants={scaleOnHover}
      className={`relative p-8 rounded-2xl backdrop-blur-sm border border-white/10 ${gradients.card} ${gradients.hover} transition-all duration-300`}
    >
      <div className={`w-16 h-16 rounded-xl ${gradient || gradients.primary} flex items-center justify-center mb-6`}>
        {icon}
      </div>
      <h3 className={`${typography.h4} ${textColors.primary} mb-4`}>{title}</h3>
      <p className={`${typography.bodyBase} ${textColors.secondary} leading-relaxed`}>{description}</p>
    </motion.div>
  );
};
